import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "../../lib/api";
import { IconBtn } from "./ui";

const REQ_STATUS = { new: "New", in_progress: "In progress", done: "Done" };

export default function RequestsAdmin() {
  const [requests, setRequests] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/requests"); setRequests(data); };
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.put(`/admin/requests/${id}/status`, { status }); load(); };
  const del = async (id) => { if (!window.confirm("Delete this request?")) return; await api.delete(`/admin/requests/${id}`); toast.success("Request deleted"); load(); };

  return (
    <div className="space-y-3" data-testid="admin-requests">
      {requests.length === 0 && <p className="text-[#5C5C5C]">No product/custom-box requests yet.</p>}
      {requests.map((r) => (
        <div key={r.id} className="bg-white border border-black/5 rounded-2xl p-5" data-testid={`request-row-${r.id}`}>
          <div className="flex justify-between gap-3 flex-wrap">
            <div className="min-w-0">
              <p className="font-semibold">{r.name} <span className="text-xs bg-[#E7E1B1] px-2 py-0.5 rounded-full ml-1">{r.kind === "custom_box" ? "Custom Box" : "Product"}</span></p>
              <p className="text-sm text-[#5C5C5C]">{r.email}{r.phone ? ` · ${r.phone}` : ""}</p>
              <p className="text-sm mt-2">{r.details}</p>
              {r.link && <a href={r.link} className="text-xs text-[#306D29] underline" target="_blank" rel="noreferrer">{r.link}</a>}
              {r.budget && <p className="text-sm font-medium text-[#306D29] mt-1">Budget: {r.budget}</p>}
            </div>
            <div className="flex flex-col items-end gap-2 shrink-0">
              <select value={r.status || "new"} onChange={(e) => setStatus(r.id, e.target.value)} data-testid={`req-status-${r.id}`}
                className={`text-xs font-semibold rounded-full px-3 py-1.5 border focus:outline-none ${r.status === "done" ? "bg-[#2D7A5D]/10 text-[#2D7A5D] border-[#2D7A5D]/30" : r.status === "in_progress" ? "bg-[#D9933B]/10 text-[#D9933B] border-[#D9933B]/30" : "bg-white text-[#0D530E] border-black/10"}`}>
                {Object.entries(REQ_STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
              <IconBtn title="Delete" danger testid={`req-del-${r.id}`} onClick={() => del(r.id)}><Trash2 size={15} /></IconBtn>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
